<!-- components/fields/ImpuestosAdicionalesFields.vue -->
<template>
  <div>
    <v-text-field
      outlined
      dense
      label="Perc. IVA"
      v-validate="'decimal:2|max:12|min:0'"
      :error-messages="errors.collect('percepcionIva')"
      data-vv-name="percepcionIva"
      v-model.number="percepcionIva"
      type="number"
      suffix="$"
      maxlength="12"
      @input="update"
    ></v-text-field>

    <v-text-field
      outlined
      dense
      label="Perc. Ingresos Brutos"
      v-validate="'decimal:2|max:12|min:0'"
      :error-messages="errors.collect('percepcionIB')"
      data-vv-name="percepcionIB"
      v-model.number="percepcionIB"
      type="number"
      suffix="$"
      maxlength="12"
      @input="update"
    ></v-text-field>

    <v-text-field
      outlined
      dense
      label="Otros Impuestos"
      v-validate="'decimal:2|max:12|min:0'"
      :error-messages="errors.collect('netoNoGravado')"
      data-vv-name="netoNoGravado"
      v-model.number="netoNoGravado"
      type="number"
      suffix="$"
      maxlength="12"
      @input="update"
    ></v-text-field>
  </div>
</template>

<script>
export default {
  name: 'ImpuestosAdicionalesFields',
  props: {
    percepcionIva: { type: Number, required: true },
    percepcionIB: { type: Number, required: true },
    netoNoGravado: { type: Number, required: true }
  },
  inject: ['$validator'],
  methods: {
    update() {
      this.$emit('update:percepcionIva', this.percepcionIva)
      this.$emit('update:percepcionIB', this.percepcionIB)
      this.$emit('update:netoNoGravado', this.netoNoGravado)
    }
  }
}
</script>
